#import "../fragments/mcfx-company-fragment.graphql"

mutation McfxViqCompanyUpdate($input: McfxViqCompanyUpdateInput!) {
    mcfxViqCompanyUpdate(input: $input) {
        mcfxCompany {
            ...McfxCompanyFragment
        }
    }
}
